import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class LoansandotherdebsService {

  URL = this.ConfigService.getAPIBaseUrl() + 'api/Loansandotherdebs/';

  constructor(public HttpClient: HttpClient, private ConfigService: ConfigurationService) { }


  SaveLoansandotherdebs(data) {
    debugger;
    return this.HttpClient.post(this.URL + "InsertLoansandotherdebs", data)
  }
 
  GetOneLoansandotherdebs(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URL + "GetLoansandotherdebs?APPeriodId=" + APPeriodId)
  }
  GetOneLoansandotherdebs_LY(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URL + "GetLoansandotherdebs_LY?APPeriodId=" + APPeriodId)
  }
}
